
import {ServerProdApi , ServerProdApidl} from '../../../src/group-cloud/network/ServerBizApi';

export const Mod_Account_Types = {
    HEAD_QUARTER: 1,    // 总部
    CLIENT: 2,          // 客户
    STORE: 3,           // 门店
}

export const Mod_Account_Type_Opts = [
    {id: Mod_Account_Types.HEAD_QUARTER, label: '总部'},    // 总部
    {id: Mod_Account_Types.CLIENT, label: '客户'},         // 客户
    {id: Mod_Account_Types.STORE, label: '门店'},         // 门店
];

export const Mod_Account_Type_Map = {};
Mod_Account_Type_Map[Mod_Account_Types.HEAD_QUARTER] = '总部';    // 总部
Mod_Account_Type_Map[Mod_Account_Types.CLIENT] = '客户';         // 客户
Mod_Account_Type_Map[Mod_Account_Types.STORE] = '门店';         // 门店

export class Mod_Account {

    public static async loadUser(userId) {

        let url = '/warehouse/find/'+userId;

        let response = await ServerProdApidl.send(url,{});

        // load user role
        // url = 'auth_center/yooz/member/get_role_list';
        // let roleRes = await ServerProdApi.send(url, formData);
        // // console.log(['role_res', roleRes]);
        //
        // let oneRole = {
        //     role_id: 0,
        // };
        //
        // if (roleRes.result && roleRes.result.length && roleRes.result[0].id > 0) {
        //     oneRole.role_id = roleRes.result[0].id;
        // }
        //
        // let ret = response.result;
        //
        // ret.one_role = oneRole;

        return response;

    }

    public static async getList(page, type, keyword) {

        let url = 'user/find/getClientOrStore';
        let formData =  {
            pageNum: page,
            pageSize: 20,
            data:{
                user_type: type,
                realname: keyword
            }

        };
        let response = await ServerProdApidl.send(url, formData);
        // if (response.succ) {
        // } else {
        //
        // }

        //修改返回
        return response.result;

    }

    public static getRecordRoleString(record) {

        let ret = '';

        let roles = [], idx;
        if (record && record.role_list && record.role_list.length) {

            for (idx = 0; idx < record.role_list.length; idx++) {
                roles.push(record.role_list[idx].rolename);
            }

            if (roles.length) {
                ret = roles.join(',');
            }
        }

        return ret;

    }
    public static getRecordTypeString(record) {

        let ret = '';

        let type = [], idx;
        if (record && record.clients && record.clients.length) {

            for (idx = 0; idx < record.clients.length; idx++) {
                type.push(record.clients[idx].type);
            }

            if (type.length) {
                ret = type.join(',');
            }
        }

        return ret;
    }

    public static async getRoles(groupId) {

        // console.log(['getRoles', groupId]);
        let url = 'rbacRole_list';
        let formData =  {
            // group_id: Mod_Account_Types.HEAD_QUARTER,
            groupId: groupId,
        };
        let response = await ServerProdApidl.send(url, formData);

        let idx, ret = [];

        if (response.result && response.result.length) {
            for (idx = 0; idx < response.result.length; idx++) {

                ret.push({
                    id: response.result[idx].id,
                    label: response.result[idx].rolename,
                });

            }
        }

        return ret;

    }

    public static async deleteUser(uid) {
        let url = 'auth_center/yooz/member/delete';
        let formData =  {
            user_id: uid,
        };
        let ret = 0;
        let response = await ServerProdApi.send(url, formData);
        return response
    }

    public static buildStatusSwitches(list) {

        let uid, idx, switches = {};

        for (idx = 0; idx < list.length; idx++) {

            uid = parseInt(list[idx].id);

            switches[uid] = -1 === parseInt(list[idx].status) ? false : true;

        }

        return switches;

    }

    public static async changeStatus(uid, val) {
        let url = 'auth_center/yooz/member/status';
        let formData =  {
            user_id: uid,
            status: val,
        };
        let ret = 0;
        let response = await ServerProdApi.send(url, formData);
        if (response.succ) {
            ret = 1;
        }
        return ret;
    }

}
